module.exports = __webpack_public_path__ + "static/media/witch-flight.4d7f9b27.svg";